import menu from '@/content/menu.json';
import Menu from './Menu';

export default function FooterMenuCommunity() {
  return <Menu title={menu.community.title} items={menu.community.items} />;
}
